import React from 'react';
import PropTypes from 'prop-types';

import Classes from './classes';
import DealTypes from './deal_types';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import Marketing from './marketing';
import Options from 'components/form/managed_input/options';
import TextOptions from './text_options';

export default function CustomFieldForm({
  allowAddingToPlaybook,
  allowTypeChange,
  customField,
  features,
  options,
  onChange,
}) {
  function changeField(changes) {
    const sanitizedChanges = Object.fromEntries(
      Object.entries(changes).map(([k, v]) => [k, v === '' ? null : v])
    );
    onChange({ ...customField, ...sanitizedChanges });
  }

  return <React.Fragment>
    {features.edge &&
      <Classes
        customField={customField}
        onChange={changeField}
      />
    }

    <ManagedFormGroup
      label="Label"
      name="label"
      required
      value={customField.label}
      onChange={changeField}
    />

    <ManagedFormGroup
      disabled={!allowTypeChange}
      includeBlank
      label="Type"
      name="type"
      required
      type="select"
      value={customField.type}
      onChange={changeField}
    >
      <Options options={options.types} />
    </ManagedFormGroup>

    <TextOptions
      customField={customField}
      onChange={changeField}
    />

    <DealTypes
      dealTypes={customField.dealTypes}
      options={options}
      onChange={changeField}
    />

    {options.categories.length > 0 &&
      <ManagedFormGroup
        label="Deal section"
        name="category"
        required
        type="select"
        value={customField.category}
        onChange={changeField}
      >
        <option value="">Custom fields</option>
        <Options options={options.categories} />
      </ManagedFormGroup>
    }

    {allowAddingToPlaybook && options.stages.length > 0 &&
      <ManagedFormGroup
        label="Add to deal playbook stage"
        name="addToStage"
        type="select"
        value={customField.addToStage}
        onChange={changeField}
      >
        <option value="">N/A</option>
        <Options options={options.stages} />
      </ManagedFormGroup>
    }

    <Marketing
      compField={customField.classFlags.comp}
      features={features}
      marketing={customField.marketing}
      options={options}
      onChange={changeField}
    />
  </React.Fragment>;
}

CustomFieldForm.propTypes = {
  allowAddingToPlaybook: PropTypes.bool,
  allowTypeChange: PropTypes.bool,
  customField: PropTypes.shape({
    category: PropTypes.string,
    dealTypes: PropTypes.array,
    label: PropTypes.string,
    marketing: PropTypes.object,
    type: PropTypes.string,
  }).isRequired,
  features: PropTypes.shape({
    edge: PropTypes.bool,
  }).isRequired,
  options: PropTypes.shape({
    categories: PropTypes.array.isRequired,
    stages: PropTypes.array.isRequired,
    types: PropTypes.array.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
